import React, { useState, useEffect } from "react";
import { Button, Modal } from "antd";
import { RadioButtonGroup } from "@vds/radio-buttons";
import { useSelector } from "react-redux";
import Grid2 from "@mui/material/Unstable_Grid2/Grid2";
import ToastNotification from "../../../global/components/ToastNotification";
import LeftArrowIcon from "../../../assets/left-arrow.svg";
import ValidationIcon, {
  getInputClassNames,
  getInputClassNamesUser,
  ErrorMessage,
} from "../../../global/components/ValidationIcon";
import { Grid } from "@mui/material";
import { useDispatch } from "react-redux";
import { createRequest, updateUI } from "../../../store/actions/shipment";
import {
  fetchDeviceRequest,
  fetchRequest,
  fetchProfileRequest,
  updateshipRequest,
  fetchDeviceNameRequest,
} from "../../../store/actions/shipment";
import {
  ShipmentStepOne,
  ShipmentStepTwo,
  ShipmentStepThree,
  ShipmentStepFour,
  ShipmentStepFive,
} from "./ShipmentProfile";
import { Select, DatePicker, Table } from "antd";
import { Input } from "@vds/inputs"
import { Checkbox } from "@vds/checkboxes";
import { MAX_CHAR_LIMITS, getCharLimitMsgIfExceeded } from "../../../global/constants/inputLimits";
import dayjs from "dayjs";
import "./Shipment.css";

const CreateShipment = ({ visible, closePopup, state, editRecord }) => {
  const dispatch = useDispatch();
  const initialFormData = {
    shipmentid: "",
    shipmentname: "",
    devicetype: "",
    deviceid: "",
    oncompletion: "",
    enabledevice: "no",
    productid: "",
    productserialnumber: "",
    trackingnumber: "",
    ordernumber: "",
    customername: "",
    ponumber: "",
    startdate: "",
    devicename: "",
    deviceprofile: {},
    ble: [],
  };

  const initialErrorData = {
    shipmentname: "",
    devicetype: "",
    deviceid: "",
    oncompletion: "",
    productid: "",
    productserialnumber: "",
    trackingnumber: "",
    ordernumber: "",
    customername: "",
    ponumber: "",
    startdate: "",
  };

  const [showNotification, setShowNotification] = useState(false);
  const [notificationProps, setNotificationProps] = useState({});
  const [currentStep, setCurrentStep] = useState(1);
  const [showTable, setShowTable] = useState(false);
  const [selectedOption, setSelectedOption] = useState("now");
  const [startDateTime, setStartDateTime] = useState(dayjs());
  const [profile, setProfile] = useState([]);
  const [formData, setFormData] = useState(initialFormData);
  const [errors, setErrors] = useState(initialErrorData);
  useEffect(() => {
    if (visible) {
      dispatch(fetchDeviceRequest());
      dispatch(fetchProfileRequest());
      dispatch(fetchDeviceNameRequest());
    }
  }, [visible, dispatch]);
  const isLoadingShipment = useSelector(
    (state) => state.shipment.isLoading.shipments
  );
  const shipments = useSelector((state) => state?.shipment?.data?.deviceType);
  const shipmetProfile = useSelector(
    (state) => state?.shipment?.data?.shipProfile
  );
  const deviceName = useSelector((state) => state?.shipment?.data?.deviceName);
  const selectedProfileId = useSelector(
    (state) => state.shipment.ui.create.selectedProfileId
  );
  const isCheckboxChecked = useSelector(
    (state) => state.shipment.ui.create.isCheckboxChecked
  );
  const filteredDevices = shipments?.devicetypes?.filter(
    (device) => device.devicemodel === "GAT"
  );
  const tableData = filteredDevices;
  const devicetypeVal = shipments?.devicetypes;
  const validateFields = (step) => {
    let tempErrors = { ...errors };
    let isValid = true;

    if (step === 1) {
      if (!formData.shipmentname) {
        tempErrors.shipmentname = "Shipment Name is required";
        isValid = false;
      } else {
        tempErrors.shipmentname = "";
      }
    }
    if (step === 2) {
      if (!formData.devicetype) {
        tempErrors.devicetype = "Device Model is required";
        isValid = false;
      } else {
        tempErrors.devicetype = "";
      }
      if (!formData.deviceid) {
        tempErrors.deviceid = "Device ID is required";
        isValid = false;
      } else {
        tempErrors.deviceid = "";
      }
      if (!formData.oncompletion) {
        tempErrors.oncompletion = "On shipment completion is required";
        isValid = false;
      } else {
        tempErrors.oncompletion = "";
      }
    }
    setErrors(tempErrors);
    return isValid;
  };
  const handleCheckboxChange = (event, profileId) => {
    dispatch(
      updateUI({
        key: "create",
        value: {
          selectedProfileId: selectedProfileId === profileId ? null : profileId,
          isCheckboxChecked: selectedProfileId !== profileId,
        },
      })
    );
  };

  const profileData = shipmetProfile
    ?.filter((item) => formData?.devicetype === item?.devicetype && item?.profiletype !=="nonshipment")
    .map((item) => ({
      devicemodel: (
        <li key={item?.profileid}>
          <div style={{ cursor: 'pointer', padding: '5px' }}>
            <RadioButtonGroup
              onChange={(e) => handleCheckboxChange(e, e.target.value)}
              error={false}
              key={item?.profileid}
              value={selectedProfileId || "undefined"} // Ensure value is defined
              data={[
                {
                  name: 'profile-selection', // same name to group radios
                  label: '',
                  children: item?.profilename,
                  value: item?.profileid,
                  ariaLabel: `Select ${item?.profilename}`,
                  disabled: false,
                },
              ]}
            />
          </div>
        </li>
      ),
      updatedon: item?.updatedon,
      createdon: item?.createdon,
      createdby: item?.createdby,
    }));


  const handleChange = (e) => {
    let profileData = [];
    const { name, value } = e.target;
    if (name === "devicetype") {
      dispatch(
        updateUI({
          key: "create",
          value: {
            selectedProfileId: null,
            isCheckboxChecked: false,
          },
        })
      );
      setShowTable(e?.target?.value);
    }
    setFormData((prevData) => {
      const newData = { ...prevData, [name]: value };
      let tempErrors = { ...errors };
      let isValid = true;
      if (currentStep === 1) {
        tempErrors.shipmentname = newData.shipmentname?.trim()
          ? ""
          : "Shipment Name is required";
        isValid = !!newData.shipmentname;
      }
      if (currentStep === 2) {
        tempErrors.devicetype = newData.devicetype
          ? ""
          : "Device Model is required";
        tempErrors.deviceid = newData.deviceid ? "" : "Device ID is required";
        tempErrors.oncompletion = newData.oncompletion
          ? ""
          : "On shipment completion is required";
        if (!selectedProfileId) {
          isValid = false;
        }
        isValid =
          newData.devicetype &&
          newData.deviceid &&
          newData.oncompletion &&
          selectedProfileId;
      }
      setErrors(tempErrors);
      return newData;
    });
  };
  const handleOptionChange = (option) => {
    setSelectedOption(option);
  };

  useEffect(() => {
    setStartDateTime(dayjs());
  }, [selectedOption]);

  const isNextButtonDisabled = () =>
    !formData.ble.every((item) => item.deviceProfile !== "") &&
    currentStep === 3 &&
    formData.enabledevice === "yes";
  const handleNext = async () => {
   if (validateFields(currentStep)) {
      if (currentStep === 1 && !formData.shipmentname?.trim()) {
          setErrors((prev) => ({
            ...prev,
            shipmentname: "Shipment Name is required",
          }));
          return;
        }
      if (currentStep === 2 && !selectedProfileId) {
        return;
      }
      setCurrentStep((prevStep) =>
        formData.enabledevice === "no" && currentStep === 2
          ? prevStep + 2
          : prevStep + 1
      );
    }
    if (currentStep == 5) {
      setFormData((prevFormData) => ({
        ...prevFormData,
        startdate: startDateTime,
      }));
      await new Promise(resolve => setTimeout(resolve, 0));
      let devicenameVal = getValueByDeviceAndKey(formData.deviceid, "name");
      let profileName = getShipmentByid(selectedProfileId, "profilename");
      let locations = getShipmentByid(selectedProfileId, "locations");
      const response = await dispatch(createRequest({ ...formData, startdate: dayjs.utc(startDateTime)?.format("MM-DD-YYYY HH:mm"), devicename: devicenameVal, deviceprofile: { id: selectedProfileId, profilename: profileName, locations: locations } }));
      if (response?.data?.shipmentid) {
        setFormData({ ...initialFormData });
        dispatch(
          updateUI({
            key: "create",
            value: {
              isOpen: false,
            },
          })
        );
        dispatch(fetchRequest());
      } else {
        dispatch(
          updateUI({
            key: "create",
            value: {
              isOpen: false,
            },
          })
        );
        setFormData({ ...initialFormData });
        setErrors({ ...initialErrorData });
        setCurrentStep(1);
        dispatch(updateUI({
          key: "create",
          value: {
            selectedProfileId: null,
            isCheckboxChecked: false,
          },
        }))
        setShowTable(false)
      }
    }
  };
  const handleBack = () => {
    setCurrentStep((prevStep) =>
      formData.enabledevice === "no" && currentStep === 4
        ? prevStep - 2
        : prevStep - 1
    );
  };
  const handleCancel = () => {
    setFormData({ ...initialFormData });
    setErrors({ ...initialErrorData });
    setCurrentStep(1);
    dispatch(
      updateUI({
        key: "edit",
        value: {
          singleEdit: false,
        },
      })
    );
    dispatch(
      updateUI({
        key: "create",
        value: {
          isOpen: false,
        },
      })
    );
    dispatch(
      updateUI({
        key: "create",
        value: {
          selectedProfileId: null,
          isCheckboxChecked: false,
        },
      })
    );
    setShowTable(false);
  };

  const blecolumns = [
    {
      title: (
        <>
          <span className="font-face-vzw">BLE device ID</span>
        </>
      ),
      dataIndex: "bledeviceid",
      key: "bledeviceid",
      width: 150,
      onHeaderCell: () => ({
        "data-tooltip": "",
      }),
      render: (text) => {
        return text;
      },
    },
    {
      title: <span className="font-face-vzw">Device name</span>,
      dataIndex: "devicename",
      key: "devicename",
      onHeaderCell: () => ({
        "data-tooltip": "",
      }),
      render: (text) => {
        return text;
      },
    },
    {
      title: <span className="font-face-vzw">Model</span>,
      dataIndex: "devicemodel",
      className: "state",
      render: (text) => <span>{text}</span>,
      key: "devicemodel",
    },
    {
      title: <span className="font-face-vzw">Device profile</span>,
      dataIndex: "revdeviceProfile",
      key: "revdeviceProfile",
      onHeaderCell: () => ({
        "data-tooltip": "",
      }),
      render: (text, record) => (
        <span>{getShipmentByid(text, "profilename")}</span>
      ),
    },
  ];
  function getShipmentByid(profileid, key) {
    const item = shipmetProfile?.find((obj) => obj.profileid === profileid);
    return item ? item[key] : null;
  }
  function getValueByUidAndKey(uid, key) {
    const item = deviceName?.devices?.find((obj) => obj.uid === uid);
    return item ? item[key] : null;
  }
  function getValueByDeviceAndKey(diviceid, key) {
    const item = deviceName?.devices?.find((obj) => obj?.uid === diviceid);
    return item ? item[key] : null;
  }
  const bleprofileData = formData?.ble?.map((item) => ({
    bledeviceid: getValueByUidAndKey(item?.uid, "minor") ?? getValueByUidAndKey(item?.uid, "serial"),
    devicename: getValueByUidAndKey(item?.uid, "name"),
    devicemodel: getValueByUidAndKey(item?.uid, "devicetype"),
    revdeviceProfile: item?.deviceProfile,
  }));
  const handleDatePickerOk = (e) => {
    setStartDateTime(dayjs(e).format("YYYY-MM-DDTHH:mm"));
  };
  return (
    <Modal
      title=""
      className="d-flex flex-column justify-content-center align-items-center p-2 shipment-clone"
      visible={visible}
      onCancel={handleCancel}
      footer={null} // We use a custom footer, so set this to null
      width={736}
      style={{ marginTop: "1%" }}
      
    >
      {showNotification && (
        <ToastNotification
          type={notificationProps.type}
          message={notificationProps.message}
          description={notificationProps.description}
          duration={notificationProps.duration}
          style={notificationProps.style}
        />
      )}

      {/* --- Part 1: Fixed Header Section --- */}
      <div>
        {currentStep !== 1 && (
          <img
            src={LeftArrowIcon}
            style={{ height: '18px', marginLeft: '-15px', marginTop: '-20px', cursor: 'pointer' }}
            alt="filter-icon"
            onClick={handleBack}
          />
        )}
        <h6 className={"page-heading-user"}>
          {state !== null && state?.createuser === undefined ? "Edit Shipment" : "Add Shipment"}
        </h6>

        {/* Conditionally render sticky sub-headings for the current step */}
        {currentStep === 2 && (
          <>
            <h6 className="model-sub-heading">Select device</h6>
            <br />
            {/* <h6 className="model-inline-heading">Device details</h6> */}
          </>
        )}
        {currentStep === 3 && <h6 className="model-sub-heading">Select BLE devices</h6>}
        {currentStep === 4 && <h6 className="model-sub-heading">Additional details</h6>}
        {currentStep === 5 && <h6 className="model-sub-heading">Review Shipment</h6>}
      </div>

      {/* --- Part 2: Scrollable Content Section --- */}
      <div
        className="scrollable-content-hidden-scrollbar"
        style={{ maxHeight: 'calc(80vh - 220px)', overflowY: 'auto', width: '100%' }}
      >
        {currentStep === 1 && (
          <Grid2 container>
            <Grid2 item xs={12} sm={12} md={12} lg={12} style={{ backgroundColor: "#FFF" }}>
              <h6 className="model-sub-heading">Shipment details</h6>
              <div className="mb-3">
                <Input
                  type="text"
                  id="shipmentname"
                  name="shipmentname"
                  value={formData.shipmentname}
                  onChange={(e) => handleChange(e)}
                  label="Shipment Name"
                  error={!!errors.shipmentname}
                  errorText={errors.shipmentname}
                  maxLength={MAX_CHAR_LIMITS.CATEGORY_TEXT}
                  required={true}
                  width="100%"
                />
                {getCharLimitMsgIfExceeded("CATEGORY_TEXT", formData?.shipmentname)}
              </div>
            </Grid2>
            <label htmlFor="startdate" className="input-label-user">
              Start date
            </label>
            <Grid container spacing={4} alignItems="center" style={{ marginTop: '-20px' }}>
              {/* Radio Button: Now */}
              <Grid item>
                <RadioButtonGroup
                  onChange={() => handleOptionChange('now')}
                  error={false}
                  value={selectedOption}
                  data={[
                    {
                      name: 'option',
                      label: '',
                      children: 'Now',
                      value: 'now',
                      ariaLabel: 'Select Now',
                      disabled: false,
                      checked: selectedOption === 'now',
                    },
                  ]}
                />
              </Grid>
              <Grid item>
                <RadioButtonGroup
                  onChange={() => handleOptionChange('future')}
                  error={false}
                  value={selectedOption}
                  data={[
                    {
                      name: 'option',
                      label: '',
                      children: 'Future',
                      value: 'future',
                      ariaLabel: 'Select Future',
                      disabled: false,
                      checked: selectedOption === 'future',
                    },
                  ]}
                />
              </Grid>
            </Grid>
            <Grid2 item xs={12} sm={12} md={12} lg={12}>
              <div className="mb-3" style={{ marginTop: "2%" }}>
                <div className="d-flex flex-column justify-content-center align-items-start py-2">
                  <DatePicker
                    key={"start-date"}
                    disabled={selectedOption === "now"}
                    className={`shipment-form-fields`}
                    style={{
                      width: "100%",
                      height: "44px",
                    }}
                    format="MM-DD-YYYY HH:mm:ss"
                    value={dayjs(startDateTime)}
                    onChange={(e) => setStartDateTime(e)}
                    showTime allowClear={false} onOk={(e) => handleDatePickerOk(e)}
                  />
                </div>
              </div>
            </Grid2>
          </Grid2>
        )}
        {currentStep === 2 && (
          <>

            <h6 className="model-inline-heading">Device details</h6>
          <Grid2 container>
            {/* The headers for this step were moved up to the fixed section */}
            <Grid2 item xs={12} sm={12} md={12} lg={12}>
              <div className="mb-3">
                <label htmlFor="devicetype" className="input-label-user">
                  Device Model
                </label>
                <div className="input-container">
                  <Select
                    className={`selectboxstyle shipment-clone-fields ${errors?.devicetype === ""
                      ? ""
                      : "shipment-form-field-error"
                      } ${formData.devicetype !== ""
                        ? "shipment-form-fields shipment-form-field-success"
                        : ""
                      }`}
                    key={"state"}
                    name="devicetype"
                    placeholder="Select Device type"
                    value={formData.devicetype}
                    onChange={(value) =>
                      handleChange({ target: { name: "devicetype", value } })
                    }
                    options={[
                      { value: "", label: "Select Device type" },
                      ...(tableData?.map((item) => ({
                        value: item?.devicetype,
                        label: item?.devicetype,
                      })) || []),
                    ]}
                  />
                </div>
                <div style={{ paddingTop: 5 }}>
                  <ErrorMessage fieldName="devicetype" errors={errors} />
                </div>
              </div>
            </Grid2>
            <Grid2 item xs={12} sm={12} md={12} lg={12}>
              <div className="mb-3">
                <label htmlFor="deviceid" className="input-label-user">
                  Device Name
                </label>
                <div className="input-container">
                  <Select
                    className={`selectboxstyle shipment-clone-fields ${errors?.deviceid === "" ? "" : "shipment-form-field-error"
                      } ${formData.deviceid !== ""
                        ? "shipment-form-fields shipment-form-field-success"
                        : ""
                      }`}
                    key={"state"}
                    name="deviceid"
                    placeholder="Select deviceid"
                    value={formData.deviceid}
                    onChange={(value) =>
                      handleChange({ target: { name: "deviceid", value } })
                    }
                    options={[
                      { value: "", label: "Select Device Name" },
                      ...(deviceName?.devices
                        ?.filter(
                          (item) =>
                            item?.kind === "ts.device.tgAssetTracker" &&
                            item?.customdata?.isAvailable === true
                        )
                        ?.map((item) => ({
                          value: item?.uid,
                          label: item?.name,
                        })) || []),
                    ]}
                  />
                </div>
                <div style={{ paddingTop: 5 }}>
                  <ErrorMessage fieldName="deviceid" errors={errors} />
                </div>
              </div>
            </Grid2>
            <Grid2 item xs={12} sm={12} md={12} lg={12}>
              <div className="mb-3">
                <label htmlFor="enabledevice" className="input-label-user">
                  Enable BLE Devices
                </label>
                <div className="input-container">
                  <Select
                    className={"selectboxstyle shipment-clone-fields"}
                    key={"state"}
                    name="enabledevice"
                    id="enabledevice"
                    value={formData.enabledevice}
                    onChange={(value) =>
                      handleChange({ target: { name: "enabledevice", value } })
                    }
                    options={[
                      {
                        value: "no",
                        label: "No",
                      },
                      {
                        value: "yes",
                        label: "Yes",
                      },
                    ]}
                  />
                </div>
              </div>
            </Grid2>
            <Grid2 item xs={12} sm={12} md={12} lg={12}>
              <div className="mb-3">
                <label htmlFor="oncompletion" className="input-label-user">
                  On shipment completion
                </label>
                <div className="input-container">
                  <Select
                    className={`selectboxstyle shipment-clone-fields ${errors?.oncompletion === ""
                      ? ""
                      : "shipment-form-field-error"
                      } ${formData.oncompletion !== ""
                        ? "shipment-form-fields shipment-form-field-success"
                        : ""
                      }`}
                    key={"state"}
                    name="oncompletion"
                    placeholder="Select Profile"
                    value={formData.oncompletion}
                    onChange={(value) =>
                      handleChange({ target: { name: "oncompletion", value } })
                    }
                    options={[
                      { value: "", label: "Select Profile" },
                      ...(shipmetProfile?.map((item) => {
                        const matchingDevice = devicetypeVal?.find(
                          (device) =>
                            device?.devicetype === item?.devicetype && device?.devicemodel === "GAT" && item?.profiletype !=="nonshipment"
                        );
                        if (matchingDevice) {
                          return {
                            value: item?.profileid,
                            label: item?.profilename,
                          };
                        }
                        return null;
                      }).filter(Boolean) || []),
                    ]}
                  />
                </div>
                <div style={{ paddingTop: 5 }}>
                  <ErrorMessage fieldName="oncompletion" errors={errors} />
                </div>
              </div>
            </Grid2>
            {showTable === false || showTable === "" ?
              (<Grid2 item xs={12} sm={12} md={12} lg={12}><br /><div className="shipment-profile-info">Select a device type to show profiles.</div></Grid2>) :
              ("")}
            {showTable && <ShipmentStepOne profile={profileData} shipmetProfile={shipmetProfile} />}
            {showTable !== "" && showTable !== false && isCheckboxChecked === false ? (<Grid2 item xs={12} sm={12} md={12} lg={12}>{selectedProfileId === null ? (<><p className="custom-error-message">
              Please Select device profile</p><br /></>) : ("")}<div className="shipment-profile-info">Select a profile to show profile summary</div></Grid2>) :
              ("")}
            {isCheckboxChecked && <ShipmentStepTwo shipmetProfile={shipmetProfile} />}
          </Grid2>
          </>
        )}
        {currentStep === 3 && (
          <Grid2
            container
            marginTop={1}
            marginBottom={2}
            spacing={1}
            columns={{ xs: 12 }}
          >
            <ShipmentStepThree
              shipmetProfile={shipmetProfile}
              formData={formData}
              setFormData={setFormData}
              errors={errors}
              handleChange={handleChange}
            />
          </Grid2>
        )}
        {currentStep === 4 && (
          <ShipmentStepFour
            formData={formData}
            errors={errors}
            handleChange={handleChange}
          />
        )}
        {currentStep === 5 && (
          <Grid2
            container
            marginTop={1}
            marginBottom={2}
            spacing={1}
            columns={{ xs: 12 }}
          >
            {/* I've added paddingLeft to this div to shift the content right */}
            <div style={{ paddingLeft: '1rem' }}>
              <h6
                className="model-inline-heading"
                style={{ marginBottom: "3%" }}
              >
                Review Shipment
              </h6>
              <h6 style={{ fontFamily: "VerizonNHGDSBold", color: "#6F7171" }}>
                Shipment details
              </h6>
              <Grid2 container spacing={2}>
                <Grid2 item xs={12} sm={4}>
                  <strong style={{ fontFamily: "VerizonNHGDSBold" }}>
                    Shipment Name
                  </strong>
                  <div>{formData.shipmentname}</div>
                </Grid2>
                <Grid2 item xs={12} sm={4}>
                  <strong style={{ fontFamily: "VerizonNHGDSBold" }}>
                    Start Date and Time
                  </strong>
                  <div>
                    {dayjs(startDateTime)?.format("MM-DD-YY [at] hh:mm:ss a")}
                  </div>
                </Grid2>
              </Grid2>
              <hr className="divider" />
              <h6 style={{ fontFamily: "VerizonNHGDSBold", color: "#6F7171" }}>
                Device details
              </h6>
              <Grid2 container spacing={2}>
                <Grid2 item xs={12} sm={4}>
                  <strong style={{ fontFamily: "VerizonNHGDSBold" }}>
                    Device Model
                  </strong>
                  <div>{formData.devicetype}</div>
                </Grid2>
                <Grid2 item xs={12} sm={4}>
                  <strong style={{ fontFamily: "VerizonNHGDSBold" }}>
                    Device Name
                  </strong>
                  <div>{getValueByDeviceAndKey(formData.deviceid, "name")}</div>
                </Grid2>
                <Grid2 item xs={12} sm={4}>
                  <strong style={{ fontFamily: "VerizonNHGDSBold" }}>
                    Device Profile
                  </strong>
                  <div>{getShipmentByid(selectedProfileId, "profilename")}</div>
                </Grid2>
                <Grid2 item xs={12} sm={4}>
                  <strong style={{ fontFamily: "VerizonNHGDSBold" }}>
                    Enable BLE Devices
                  </strong>
                  <div>{formData.enabledevice == "no" ? "No" : "Yes"}</div>
                </Grid2>
                <Grid2 item xs={12} sm={4}>
                  <strong style={{ fontFamily: "VerizonNHGDSBold" }}>
                    On Shipment Completion
                  </strong>
                  <div>
                    {getShipmentByid(formData.oncompletion, "profilename")}
                  </div>
                </Grid2>
              </Grid2>
              <hr className="divider" />
              {formData?.enabledevice === "yes" && formData?.ble?.length > 0 ? (
                <>
                  <h6
                    style={{ fontFamily: "VerizonNHGDSBold", color: "#6F7171" }}
                  >
                    BLE details
                  </h6>
                  <Grid2 container spacing={2}>
                    <Grid2 item xs={12} sm={12}>
                      <Table
                        loading={isLoadingShipment}
                        style={{ tableLayout: "revert-layer" }}
                        rowKey="shipment-row-key"
                        columns={blecolumns}
                        dataSource={bleprofileData}
                        pagination={false}
                      />
                    </Grid2>
                  </Grid2>
                  <hr className="divider" />
                </>
              ) : (
                ""
              )}
              <h6 style={{ fontFamily: "VerizonNHGDSBold", color: "#6F7171" }}>
                Additional Details
              </h6>
              <Grid2 container spacing={2}>
                <Grid2 item xs={12} sm={4}>
                  <strong style={{ fontFamily: "VerizonNHGDSBold" }}>
                    Product ID
                  </strong>
                  <div>{formData.productid}</div>
                </Grid2>
                <Grid2 item xs={12} sm={4}>
                  <strong style={{ fontFamily: "VerizonNHGDSBold" }}>
                    Product Serial Number
                  </strong>
                  <div>{formData.productserialnumber}</div>
                </Grid2>
                <Grid2 item xs={12} sm={4}>
                  <strong style={{ fontFamily: "VerizonNHGDSBold" }}>
                    Tracking Number
                  </strong>
                  <div>{formData.trackingnumber}</div>
                </Grid2>
                <Grid2 item xs={12} sm={4}>
                  <strong style={{ fontFamily: "VerizonNHGDSBold" }}>
                    Order Number
                  </strong>
                  <div>{formData.ordernumber}</div>
                </Grid2>
                <Grid2 item xs={12} sm={4}>
                  <strong style={{ fontFamily: "VerizonNHGDSBold" }}>
                    Customer Name
                  </strong>
                  <div>{formData.customername}</div>
                </Grid2>
                <Grid2 item xs={12} sm={4}>
                  <strong style={{ fontFamily: "VerizonNHGDSBold" }}>
                    PO Number
                  </strong>
                  <div>{formData.ponumber}</div>
                </Grid2>
              </Grid2>
            </div>
          </Grid2>
        )}
      </div>

      {/* --- Part 3: Custom Footer Section --- */}
      <Grid2 container marginTop={0.5} spacing={1} columns={{ xs: 12 }}>
        <Grid2 item xs={12} sm={6} md={6} lg={6}>
          <div className="mb-3">
            <Button
              className="custom-button-cancel"
              type="default"
              onClick={handleBack}
              shape="round"
              disabled={currentStep !== 1 ? false : true}
              style={{
                fontWeight: "bolder",
                width: "100%",
                fontFamily: "VerizonNHGDS",
              }}
              size={"large"}
            >
              Back
            </Button>
          </div>
        </Grid2>
        <Grid2 item xs={12} sm={6} md={6} lg={6}>
          <div className="mb-3">
            <Button
              className="custom-button-save"
              type="primary"
              onClick={handleNext}
              disabled={isNextButtonDisabled()}
              shape="round"
              style={{
                width: "100%",
                backgroundColor: "black",
                color: "white",
                fontSize: "bolder",
                fontFamily: "VerizonNHGDS",
              }}
              size={"large"}
            >
              {currentStep === 5 ? "Add" : "Next"}
            </Button>
          </div>
        </Grid2>
      </Grid2>
    </Modal>
  );
};

export default CreateShipment;
